import React from 'react';
import axios from 'axios';
import { lawsAPIToken } from '~api/laws';
import { withRouter } from 'react-router-dom';
import { withNamespaces, Trans } from 'react-i18next';
import Input from '~components/input';
import LoadingButton from '~components/loading-button';
import { iconBackBtn } from '~utils/svgIcons';
import { toast } from 'react-toastify';
import { ErrorMessage } from '~components/toast';
import validate from 'validate.js';
import validationRules from '~utils/validator';
import '~routes/login-page/style.scss';
import './style.scss';

function ResetForm({ isMobile, backCallback }) {
    const [state, setState] = React.useState({
        email: {
            value: '',
            isInvalid: false,
            error: <Trans i18nKey="validationRules.required-message" />,
        },
        captcha: {
            value: '',
            isInvalid: false,
            error: <Trans i18nKey="validationRules.required-message" />,
        },
    });

    const [captchaData, setCaptchaData] = React.useState({
        captcha_id: '',
        captcha_url: '',
    });

    const [sended, setSended] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);

    const onChangeHandler = React.useCallback(
        (event) => {
            setState({
                ...state,
                [event.target.name]: {
                    value:
                        event.target.name === 'captcha'
                            ? event.target.value.trim().toUpperCase()
                            : event.target.value.trim(),
                    isInvalid: false,
                    error: '',
                },
            });
        },
        [state]
    );

    const onFormSubmit = React.useCallback(
        async (event) => {
            event.preventDefault();

            if (!state.email.value) {
                setState({
                    ...state,
                    email: {
                        value: '',
                        isInvalid: true,
                        error: <Trans i18nKey="validationRules.required-message" />,
                    },
                });
            }

            // Валидируем все данные формы перед отправкой:
            let validatedData = {};
            const validatorAnswer = validate(
                {
                    email: state.email.value,
                },
                {
                    email: validationRules.email,
                }
            );

            const isValid = typeof validatorAnswer === 'undefined';

            if (!isValid) {
                const { email } = validatorAnswer;
                validatedData = {
                    ...state,
                    email: {
                        value: state.email.value,
                        isInvalid: Boolean(email),
                        error: email ? validatorAnswer.email[0] : '',
                    },
                };
                setState(validatedData);
                return;
            }

            if (!state.captcha.value) {
                setState({
                    ...state,
                    captcha: {
                        value: '',
                        isInvalid: true,
                        error: <Trans i18nKey="validationRules.required-message" />,
                    },
                });
                return;
            }

            setLoading(true);

            lawsAPIToken()
                .post('/users/send_password_recovery_email/', {
                    captcha_response: state.captcha.value,
                    captcha_id: captchaData.captcha_id,
                    email: state.email.value,
                })
                .then(({ data }) => {
                    const { success, captcha } = data;
                    if (!success) {
                        const { captcha_id, captcha_url } = captcha;
                        setCaptchaData({ captcha_id, captcha_url });
                        setState({
                            ...state,
                            captcha: {
                                value: '',
                                isInvalid: true,
                                error: 'Неверный код с картинки',
                            },
                        });
                    }
                    setLoading(false);
                    if (success) setSended(true);
                })
                .catch((error) => {
                    if (!axios.isCancel(error)) {
                        toast(<ErrorMessage message={error.message} />);
                    }
                    setLoading(false);
                });
        },
        [state, captchaData]
    );

    React.useEffect(() => {
        lawsAPIToken()
            .post('/users/init_captcha/')
            .then(({ data }) => {
                const { captcha_id, captcha_url } = data;
                setCaptchaData({ captcha_id, captcha_url });
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                    toast(<ErrorMessage message={error.message} />);
                }
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { email, captcha } = state;

    return (
        <form className="reset-form">
            <button type="button" className="reset-form__back-button" onClick={backCallback}>
                {iconBackBtn('#C31B1C')}
            </button>
            {sended ? (
                <h3 className="login-page__header">На указанную почту отправлена ссылка для смены пароля</h3>
            ) : (
                <React.Fragment>
                    <h3 className="login-page__header">Восстановление пароля</h3>
                    <Input
                        type="email"
                        placeholder="E-mail"
                        name="email"
                        onChange={onChangeHandler}
                        value={email.value}
                        isError={email.isInvalid}
                        message={email.error}
                    />
                    <img src={captchaData.captcha_url} alt="captcha" className="reset-form__captcha" />
                    <Input
                        type="text"
                        placeholder="Введите код с картинки"
                        name="captcha"
                        onChange={onChangeHandler}
                        value={captcha.value}
                        isError={captcha.isInvalid}
                        message={captcha.error}
                        disabled={!captchaData.captcha_url}
                    />
                    <LoadingButton
                        type="submit"
                        size={isMobile ? 'small' : 'big'}
                        onClick={onFormSubmit}
                        isMobile={isMobile}
                        ariaLabel="Восстановить пароль"
                        isLoading={isLoading}
                        disabled={isLoading}
                    >
                        Восстановить пароль
                    </LoadingButton>
                </React.Fragment>
            )}
        </form>
    );
}

export default withRouter(withNamespaces('translation')(ResetForm));



// WEBPACK FOOTER //
// ./src/routes/login-page/login/reset-password-form/index.js